module.exports = __webpack_public_path__ + "static/media/bg-blur.51f968c5.jpg";